import React from 'react';
import { Linkedin, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { contact, site, nav } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#D1F9F1] border-t border-[#B5BDC8] py-14 mt-8">
      <div className="container-x grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="heading-serif text-[#232830] text-[22px] leading-tight">{site.name}</div>
          <div className="text-[10px] tracking-[0.22em] text-[#546072] uppercase mt-2">{site.tagline}</div>
          <p className="mt-5 text-[#232830] text-[13.5px] leading-relaxed max-w-md">
            The clinical research group of Dr Joseph Cheriyan at Cambridge University Hospitals and the University of Cambridge,
            focused on early-phase cardiovascular clinical trials, vascular function and experimental medicine.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#546072] mb-4">Sections</div>
          <ul className="space-y-2">
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-[#232830] hover:text-[#133844] text-[13.5px] transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#546072] mb-4">Programmes</div>
          <ul className="space-y-2">
            <li>
              <Link to="/ignite" className="text-[#232830] hover:text-[#133844] text-[13.5px] transition-colors">
                IGNITE · Innovation & experimental medicine
              </Link>
            </li>
            <li>
              <Link to="/trials-office" className="text-[#232830] hover:text-[#133844] text-[13.5px] transition-colors">
                Cardiovascular Trials Office
              </Link>
            </li>
            <li>
              <Link to="/echo" className="text-[#232830] hover:text-[#133844] text-[13.5px] transition-colors">
                Research Echo Service
              </Link>
            </li>
            <li>
              <Link to="/publications" className="text-[#232830] hover:text-[#133844] text-[13.5px] transition-colors">
                Publications
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#546072] mb-4">Profiles</div>
          <ul className="space-y-2">
            <li>
              <a href={contact.cambridge} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#232830] hover:text-[#133844] text-[13.5px]">
                <ExternalLink className="h-3.5 w-3.5" /> University of Cambridge profile
              </a>
            </li>
            <li>
              <a href={contact.nhs} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#232830] hover:text-[#133844] text-[13.5px]">
                <ExternalLink className="h-3.5 w-3.5" /> Cambridge University Hospitals
              </a>
            </li>
            <li>
              <a href={contact.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#232830] hover:text-[#133844] text-[13.5px]">
                <Linkedin className="h-3.5 w-3.5" /> LinkedIn
              </a>
            </li>
            <li>
              <a href={contact.scholar} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#232830] hover:text-[#133844] text-[13.5px]">
                <ExternalLink className="h-3.5 w-3.5" /> Google Scholar
              </a>
            </li>
            <li>
              <a href={contact.orcid} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#232830] hover:text-[#133844] text-[13.5px]">
                <ExternalLink className="h-3.5 w-3.5" /> ORCID
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-10 pt-5 border-t border-[#B5BDC8] flex flex-wrap items-center justify-between gap-4">
        <div className="text-[#546072] text-[11.5px] leading-relaxed">
          © {new Date().getFullYear()} {site.name}. All rights reserved.
          <span className="block sm:inline sm:ml-2 text-[#8892A0]">
            Affiliated with Cambridge University Hospitals NHS Foundation Trust and the University of Cambridge. This is a personal research-group website and is not an official publication of either institution.
          </span>
        </div>
        <div className="text-[#546072] text-[11.5px]">This site does not provide clinical advice.</div>
      </div>
    </footer>
  );
}
